// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__forum-comment-like .btn[data-v-2e73da0e]:focus{box-shadow:none!important}", ""]);
// Exports
module.exports = exports;
